import { useState } from 'react';
import { nextSettledCount } from '../utils/statsCount';

/**
 * The last row count the backend actually returned, held steady while a
 * refetch triggered by a search or filter change is in flight. Returns
 * `undefined` until the first count settles.
 *
 * Updates during render via React's "storing information from previous
 * renders" pattern rather than an effect; the transition itself lives in the
 * unit-tested `nextSettledCount`.
 */
export function useSettledCount(
  count: number | undefined,
  isLoading?: boolean
): number | undefined {
  const [settled, setSettled] = useState<number | undefined>(undefined);

  const next = nextSettledCount(settled, count, !!isLoading);
  if (next.changed) setSettled(next.value);

  return next.value;
}
